import { InfoTip } from './InfoTip'

export interface SegmentedOption<T extends string> {
  value: T
  label: string
  title?: string
}

interface Props<T extends string> {
  label: string
  /** 指定すると項目名の横に ⓘ アイコンを出し、この文言を説明として表示する */
  hint?: string | undefined
  value: T
  options: readonly SegmentedOption<T>[]
  onChange: (value: T) => void
}

export function SegmentedControl<T extends string>({
  label,
  hint,
  value,
  options,
  onChange,
}: Props<T>) {
  return (
    <div className="field">
      <span className="field-label">
        {label}
        {hint && <InfoTip label={label} text={hint} />}
      </span>
      <div className="segmented" role="group" aria-label={label}>
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            className="segmented-option"
            aria-pressed={option.value === value}
            title={option.title}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  )
}
